export enum HttpStatusCodeEnum {
    OK = 200,
    Accepted = 202,
    NotFound = 404
}
